/**
 * PKG-015: SYSTEM URL AUTHORITY REGISTRY (FRONTEND)
 * This is the SINGLE source of truth for URLs in the Frontend.
 * Authority: URL_AUTHORITY_LOCK.json
 */

export const getBackendUrl = () => {
    const authority = process.env.REACT_APP_BACKEND_URL;

    // Soft Coding Invariant: Localhost DX fallback
    if (!authority && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
        console.warn("URL_AUTHORITY_WARNING: REACT_APP_BACKEND_URL missing. Defaulting to localhost:8000 for DX.");
        return 'http://localhost:8000';
    }

    if (!authority) {
        console.error("CRITICAL: NETWORK_AUTHORITY_DRIFT DETECTED.");
        console.error("Reason: REACT_APP_BACKEND_URL is missing from environment.");
        throw new Error("NETWORK_AUTHORITY_DRIFT: Mandatory authority missing.");
    }

    return authority;
};
